class CommonUtilityClass {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor,@typescript-eslint/no-empty-function
  constructor() {}

  // eslint-disable-next-line class-methods-use-this
  convertStringToBoolean(value: string | null | undefined): boolean {
    // null、undefined は false
    if (!value) {
      return false;
    }

    // 小文字にして判定
    return value.toLowerCase() === 'true' || value === '1';
  }

  // eslint-disable-next-line class-methods-use-this
  convertStringToNumber(str: string): number {
    return Number(str.replace(/[^0-9]/g, ''));
  }

  // eslint-disable-next-line class-methods-use-this
  convertNumberToString(number: number): string {
    return number.toString();
  }

  // eslint-disable-next-line class-methods-use-this
  convertArrayToObject(array: Array<number> | [], key: string = ''): Object {
    const obj: any = Object.create(null);
    const regExp: RegExp = /[.\[\]]/;
    const keys: string[] = key.split(regExp).filter((str) => str.length !== 0);
    array.forEach((value: number | [], index) => {
      if (typeof value === 'string' || typeof value === 'number') {
        obj[value] = value;
        return;
      }
      const _key = keys.reduce((acc, cur) => acc[cur], value as any);
      if (typeof _key !== 'string' && typeof _key !== 'number') {
        throw new Error(`array[${index}].${key} is ${typeof _key}. not string or number !!`);
      }
      obj[_key] = value;
    });
    return obj;
  }

  // eslint-disable-next-line class-methods-use-this
  groupBy(xs: any, key: any) {
    return xs.reduce(function (rv: any, x: any) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, []);
  }

  // eslint-disable-next-line class-methods-use-this
  convertTypeArrayNumber = (array: string[] | []): Array<number> => {
    return array.map((item) => Number(item));
  };

  // 引数に渡したデータを環境変数に応じて返す
  getEnvBasedValue<T>(
    { production, staging, development }: { production: T; staging: T; development: T },
    appEnv: string,
  ): T {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const dummyThis = this; // thisを使用するためのダミー変数

    switch (appEnv) {
      case 'staging':
        return staging;
      case 'development':
        return development;
      default:
        return production;
    }
  }
}

const CommonUtility = new CommonUtilityClass();
export default CommonUtility;
